export class CriteriaFromStringBuilderViewModel
{
    opened: boolean = false;

    parentId: number | null = null;
    parentName: string | null = null;

    show(parentId: number, parentName: string)
    {
        this.parentId = parentId;
        this.parentName = parentName;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.parentId = null;
        this.parentName = null;
    }
}